export enum State {
  Default = 'Default',
  Creating = 'Creating',
  EditSelection = 'EditSelection',
  ReadyForEdit = 'ReadyForEdit',
  DeleteSelection = 'DeleteSelection',
  ReadyForDelete = 'ReadyForDelete',
}
